module.exports = __webpack_public_path__ + "img/mobile-banking.28d3ba12.svg";